<p class="step-help-text">Choose one of the following options to proceed.</p>
<form [formGroup]="createOrUploadForm">
    <mat-radio-group formControlName="upsertAction">
        <mat-radio-button [value]="dealerLockoutUpsertImageAction.UPLOAD" class="radio-option">Upload Your Own</mat-radio-button>
        <p class="step-help-text radio">The image must be 1024px x 600px in PNG or JPG format.</p>

        <hr class="create-lockout-divider" />

        <mat-radio-button [value]="dealerLockoutUpsertImageAction.CREATE" class="radio-option">Create Screen</mat-radio-button>
        <p class="step-help-text radio">Creating a custom screen allows you to quickly add contact info, your logo with a tagline</p>
    </mat-radio-group>
</form>
